export enum Status {
  NOT_APPLY,
  APPLIED,
  GROUP_MEETING,
  CAMERA_TEST,
  FINALIST
}
